import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchExternalPlatforms = () =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/admin/external_platforms', utilizePagination: false })
    handleCall(req, resolve, reject)
  })
